import { Heading } from 'components/ui';

type Props = {
  hasBookedMeeting?: boolean;
};

export const ThankYouHeading = ({ hasBookedMeeting }: Props) => (
  <Heading textStyle="heading.h2">
    {hasBookedMeeting ? (
      <>
        Your care continues in
        <br />
        the Ayble Health app
      </>
    ) : (
      <>
        Your care starts
        <br />
        with your first visit
      </>
    )}
  </Heading>
);

export default ThankYouHeading;
